// components/invoices/InvoiceRow.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import InvoiceStatusBadge from '../common/InvoiceStatusBadge';
import PayoutStatusBadge from '../common/PayoutStatusBadge';
import { formatDate, formatCurrency } from './utils/formatters';
import styles from './Invoices.module.css';

const InvoiceRow = ({ invoice, projectsData }) => {
  const navigate = useNavigate();
  
  const projectDescription = projectsData[invoice.projectId]?.description || 'Unknown Project';

  return (
    <tr 
      onClick={() => navigate(`/invoices/${invoice.id}`)}
      className={styles.tableRow}
    >
      <td>
        <InvoiceStatusBadge status={invoice.status} dueDate={invoice.dueDate} />
      </td>
      <td>
        <div className={styles.customerInfo}>
          <div className={styles.customerName}>{invoice.customerInfo.name}</div>
          <div className={styles.customerEmail}>{invoice.customerInfo.email}</div>
        </div>
      </td>
      <td>
        <div className={styles.projectDescription} title={projectDescription}>
          {projectDescription}
        </div>
      </td>
      <td className={styles.invoiceNumber}>
        {invoice.stripe?.invoiceNumber || 'N/A'}
      </td>
      <td className={styles.amountCell}>
        {formatCurrency(invoice.financials?.subtotal)}
      </td>
      <td className={styles.dateCell}>
        {formatDate(invoice.sentAt)}
      </td>
      <td className={styles.dateCell}>
        {invoice.dueDate ? new Date(invoice.dueDate).toLocaleDateString('en-GB') : '---'}
      </td>
      <td>
        <PayoutStatusBadge invoice={invoice} />
      </td>
    </tr>
  );
};

export default InvoiceRow;